import request from './request'

// 通用请求方法
export function http_post(url, data, loading = false) {
  return request({
    url: url,
    method: 'post',
    data,
    loading: loading
  })
}

export function http_get(url, loading = false) {
  return request({
    url: url,
    method: 'get',
    loading: loading
  })
}

// 登陆 或 注册
export function login(data) {
  return request({
    url: '/api/admin/auth/login',
    method: 'post',
    data
  })
}


// 获取管理员信息
export function admin_info() {
  return request({
    url: '/api/admin/auth/info',
    method: 'get'
  })
}


export function getPageList(data) {
  return request({
    url: '/api/dev/page/lists',
    method: 'post',
    data,
    loading: 1
  })
}

export function getPageInfo(data) {
  return request({
    url: '/api/dev/page/info',
    method: 'post',
    data,
    loading: 1
  })
}

export function addPage(data) {
  return request({
    url: '/api/dev/page/add',
    method: 'post',
    data,
    loading: 1
  })
}

export function delPage(data) {
  return request({
    url: '/api/dev/page/delete',
    method: 'post',
    data,
    loading: true
  })
}

